import { Form } from "antd";
import { FormInstance } from "rc-field-form";
import React from "react";
import { InputNumberStd } from "src/components/InputNumberStd";
import styles from "../EditorInfo2.module.less";
import { edCompField } from "../ParamsEditorInfo2";

export const TextAreaEdProps: React.FC = () => (
  <>
    <Form.Item
      name={edCompField("maxLength")}
      label="Максимальное количество символов"
    >
      <InputNumberStd precision={0} />
    </Form.Item>
    <div className={styles.twoCols}>
      <Form.Item name={edCompField("minRows")} label="Мин. строк">
        <InputNumberStd min={1} precision={0} />
      </Form.Item>
      <Form.Item
        name={edCompField("maxRows")}
        label="Макс. строк"
        dependencies={[edCompField("minRows")]}
        rules={[
          (formInst: FormInstance) => ({
            validator: (_, value) => {
              const minRows = formInst.getFieldValue(edCompField("minRows"));
              if (minRows && value && minRows > value)
                return Promise.reject(
                  Error("не может быть меньше Мин. значения"),
                );
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumberStd min={1} precision={0} />
      </Form.Item>
    </div>
  </>
);
